import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const WHATS_NEW_ENDPOINTS = {
  V1: createEndpoints('v1', {
    LIST: '/admin/list-whats-new-notifications',
    SOFT_DELETE: '/admin/soft-delete-whats-new-notification',
    RETRIEVE: (id: number) => `/admin/retrieve-whats-new-notification/${id}`,
    USER_TYPES: '/admin/list-whats-new-user-types',
    UPDATE: (id: number) => `/admin/update-whats-new-notification/${id}`,
    CREATE: '/admin/create-whats-new-notification',
    PUBLISHED_LIST: '/admin/published-whats-new-notification-list',
    TOGGLE_READ: (id: number) => `/admin/toggle-whats-new-notifications/${id}`,
    READ_ALL: '/admin/read_all-whats-new-notifications',
  }),
} as const;
